export const getTopicsList = (store) => store.topics.topics;

export const getTopicsCount = (store) => store.topics.topics.length;

export const getIsLoading = store => store.topics.isLoading;
